import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },
  fetchFraudplusPackages(
    { state },
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.fraudPlusPath.getfraudpluspackages
        }?PageNumber=${pageNumber}&PageSize=${pageSize}&Key=${key}&Value=${value}&SortBy=${sortBy ||
          'PackageCode'}&SortDirection=${sortDirection || 'Ascending'}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchARSFraudXSortData(state, sortData) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.fetchARSFraudXSortData}/${sortData.orderId}/${sortData.sortBy}/${sortData.sortType}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getFraudplusFinalReport(state, orderId) {
    let url = `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.getFraudplusFinalReport}?orderId=${orderId}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        console.log(error)
      })
  },
  fetchFraudXPDF(state, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.fetchFraudXPDF}?orderid=${payload.orderId}&section=${payload.section}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        console.log(error)
      })
  },
    fetchFraudXPDFv2(state, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.fetchFraudXPDFv2}?orderid=${payload.orderId}&section=${payload.section}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        console.log(error)
      })
  },
  fetchFPlusRolesForBridger(state) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.getFPlusRolesForBridger}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchFPlusPackageDetails({ state }, { packageCode }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.getFraudplusPackageDetails}/${packageCode}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchFRaudXPackageDetails({ state }, packageId) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.fetchFRaudXPackageDetails}?packageid=${packageId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  enableDisableFraudPlusPackage({ state }, { packageStatusData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.enableDisableFraudPlusPackage}`,
        packageStatusData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  saveRemarks({ state }, { comments, orderID } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.saveRemarks}?description=${comments}&orderid=${orderID}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  saveStatus(
    { state },
    { CommentsDescription, StatusDescription, Status, riskindicatorid } = {}
  ) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.saveStatus}`,
        { CommentsDescription, StatusDescription, Status, riskindicatorid },
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  getManageList(state) {
    let url = `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.getManageList}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getCustomerList(state, { customerid }) {
    let url = `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.getCustomerList}?customerid=${customerid}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getCustomerPackage(state, { customerid }) {
    let url = `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.getCustomerPackage}?customerid=${customerid}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        console.log(error)
      })
  },
  putAction({ state }, { id, status, lastupdate } = {}) {
    return axios
      .put(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.putAction}?id=${id}&status=${status}&lastupdate=${lastupdate}`,
        {},
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  editCustomerList({ state }, { packageCode } = {}) {
    console.log(packageCode)
    return axios
      .put(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.editCustomerList}`,
        packageCode,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  deleteCustomerList({ state }, { id } = {}) {
    return axios
      .delete(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.deleteCustomerList}?id=${id}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  createFPlusPackage({ state }, { packageCreateData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.createFraudplusPackage}`,
        packageCreateData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
        // return {
        //   data: {
        //     id: 1,
        //     externalId: null,
        //     responseStatus: 1,
        //     message: 'Fraudplus Package updated successfully.',
        //   },
        // }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  saveFPlusPackage({ state }, { packageData } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.saveFraudPlusPackage}`,
        packageData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchAllCustomers({ state }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.getFraudplusPackageCustomers}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchselectedCustomers({ state }, packageId) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.getFraudplusPackageAssignments}/${packageId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  saveSelectedCustomers({ state }, selectedCustomers) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.assignFraudplusPackage}`,
        selectedCustomers,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  async getFraudPlusPricingData({ commit }, customerId) {
    let url = `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.getFraudPlusPricingData}?customerId=${customerId}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        console.log(error)
      })
  },

  async postFraudPlusPricingData({ commit }, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.saveFraudPlusPricingData}`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        var errorMsg = error.response
        if (errorMsg !== '') {
          alert(errorMsg)
        } else {
          return error
        }
      })
  },
  getFraudPlusOrderSummary({ state }, orderID) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.getFraudPlusOrderSummary}?orderid=${orderID}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  getFraudPlusViewReport({ state }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.fraudPlusPath.fraudplusViewReport}?orderid=${payload.uID}&operatorname=${payload.operatorName}`,
        '',
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
